// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nZvx","right":"styles_right__uVW1K"};